/**
 * Since 2022-12 Phyron is no longer supported. This code is left for
 * backwards compatibility & documentation purposes.
 *
 * In order to re-enable Phyron support, remove the line `return false`
 * from PhyronHelper function on row 20.
 * */

export const PhyronSettings = {
    width: 828,
    height: 518,
    get dimesions(){ 
        return `${this.width}x${this.height}`
    },
}

const PhyronHelper = async (regnr) => {

    /* Disable Phyron by always returning false */
    return false;

    function checkImage(regnr) {
        return new Promise((resolve, reject) => {
            var http = new XMLHttpRequest();

            http.open('HEAD', `https://bilbolaget-nu.cust.se.phyron.com/repo/${regnr}/${PhyronSettings.dimesions}-thumb-play.jpg`, false);
            http.send();
        
            http.status !== 404 
                ? resolve()
                : reject()
        })
    }

    return await checkImage(regnr)
        .then(() => { 
            phyronPlayerLoader()
            return true 
        })
        .catch(() => { return false })

}

export default PhyronHelper


const phyronPlayerLoader = (cb) => {
    const scriptID = 'phyron-player'
    const phyronScript = document.getElementById(scriptID)

    if(!phyronScript) {
        const script = document.createElement('script')
        script.src = 'https://bilbolaget-nu.cust.se.phyron.com/phyron2.js'
        script.id = scriptID
        document.body.appendChild(script)

        script.onload = () => {
            if(cb) { cb() }
        }
    }
}